import styled from "styled-components"

import { useGetReferralAgentLinkQrFunnelQuery } from "store/api/referralsApi"

import { Spinner } from "components/common/Spinner"

import { buildLinkFunnel } from "./linkFunnelData"
import { Card, CardHeader, CardTitle } from "./shared"

const RateBadge = styled.span`
  padding: 4px 10px;
  border-radius: 999px;
  background: var(--status-success-subtle);
  font-size: 12px;
  font-weight: 600;
  color: var(--status-success-text);
  white-space: nowrap;
`

const Row = styled.div`
  &:not(:last-of-type) {
    margin-bottom: 16px;
  }
`

const RowHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  font-size: 13px;
  color: var(--text-primary);
`

const RowValue = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);

  small {
    margin-left: 4px;
    font-size: 12px;
    font-weight: 400;
    color: var(--text-muted);
  }
`

const Track = styled.div`
  height: 8px;
  border-radius: 999px;
  background: var(--surface-3);
  overflow: hidden;
`

const Fill = styled.div<{ $width: number; $color: string; $soft?: boolean }>`
  height: 100%;
  border-radius: 999px;
  width: ${({ $width }) => $width}%;
  background: ${({ $color }) => $color};
  opacity: ${({ $soft }) => ($soft ? 0.5 : 1)};
`

const Message = styled.p`
  margin: 0;
  font-size: 14px;
  color: var(--text-muted);
`

const Footnote = styled.p`
  margin: 16px 0 0;
  font-size: 12px;
  line-height: 18px;
  color: var(--text-muted);
`

export const LinkFunnelCard = () => {
  const { data, isLoading, isError } = useGetReferralAgentLinkQrFunnelQuery()
  const funnel = data?.data ? buildLinkFunnel(data.data) : null

  const renderBody = () => {
    if (isLoading) return <Spinner />
    if (isError || !funnel) return <Message>The funnel is unavailable right now.</Message>

    return funnel.rows.map(({ label, value, percent, color, soft, width }) => (
      <Row key={label}>
        <RowHeader>
          {label}
          <RowValue>
            {value}
            {percent && <small>{percent}</small>}
          </RowValue>
        </RowHeader>
        <Track>
          <Fill $width={width} $color={color} $soft={soft} />
        </Track>
      </Row>
    ))
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Link &amp; QR funnel</CardTitle>
        {funnel && <RateBadge>{funnel.installRate}</RateBadge>}
      </CardHeader>
      {renderBody()}
      <Footnote>How clients who opened your link or scanned your QR are converting into installed homes.</Footnote>
    </Card>
  )
}
